export default __webpack_public_path__ + "static/media/more-features-ar.e2df1dab.png";